import { Button } from '@heidi/design-system/button';
import { TypographyP2 } from '@heidi/design-system/typography';
import { Trash2 } from 'lucide-react';
import type { ReactNode } from 'react';

/** Reusable row for a removable document item (existing or staged). */
export const RemovableDocRow = ({
  icon,
  label,
  onRemove,
  removeLabel,
}: {
  icon: ReactNode;
  label: string;
  onRemove: () => void;
  removeLabel: string;
}) => (
  <div className="flex items-center gap-2 px-1 py-2.5">
    <div className="flex size-5 shrink-0 items-center justify-center">{icon}</div>
    <div className="min-w-0 flex-1">
      <TypographyP2 className="truncate" title={label}>
        {label}
      </TypographyP2>
    </div>
    <Button
      type="button"
      variant="destructive_ghost"
      size="xs"
      iconOnly
      className="shrink-0"
      onClick={onRemove}
      aria-label={removeLabel}
    >
      <Trash2 size={14} />
    </Button>
  </div>
);
